import React from 'react';
import { Box, Typography } from '@mui/material';
import { C, T } from './leadOverviewCardTokens';

export const formatHeadingTitleCase = (value) => {
  const s = String(value ?? '').trim();
  if (!s) return '';
  return s
    .split(/\s+/)
    .map((word) => {
      if (!word) return word;
      if (word === '&') return '&';
      if (/^[·•]+$/.test(word)) return word;
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');
};

export const OverviewCardTitleWithIcon = ({ icon, iconBg = C.bg2, title, sx = {}, boxSize = 28, fontSize = '12px' }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', minWidth: 0, ...sx }}>
    <Box
      sx={{
        width: boxSize,
        height: boxSize,
        borderRadius: '8px',
        bgcolor: iconBg,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '14px',
        flexShrink: 0,
      }}
    >
      {icon}
    </Box>
    <Typography sx={{ ...T.cardTitle, fontSize, color: C.slate2, lineHeight: 1.35 }}>{formatHeadingTitleCase(title)}</Typography>
  </Box>
);

export const ClosedCard = ({
  title,
  right,
  children,
  sx = {},
  headerSx = {},
  titleSx = {},
  iconEmoji,
  iconBg,
  headerIconSize = 26,
}) => (
  <Box
    sx={{
      bgcolor: C.white,
      border: `1px solid ${C.border}`,
      borderRadius: '12px',
      boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
      p: '16px',
      minHeight: 0,
      ...sx,
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2, mb: 1.25, ...headerSx }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0, flex: 1 }}>
        {iconEmoji ? (
          <Box
            sx={{
              width: headerIconSize,
              height: headerIconSize,
              borderRadius: '8px',
              bgcolor: iconBg || C.bg2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: headerIconSize >= 28 ? '14px' : '13px',
              flexShrink: 0,
            }}
          >
            {iconEmoji}
          </Box>
        ) : null}
        <Typography sx={{ ...T.cardTitle, ...titleSx }}>{formatHeadingTitleCase(title)}</Typography>
      </Box>
      {right ? <Box sx={{ flexShrink: 0 }}>{right}</Box> : null}
    </Box>
    {children}
  </Box>
);
